export var EHotspotType;
(function (EHotspotType) {
    EHotspotType["MOVEMENT"] = "movement";
    EHotspotType["INFORMATION"] = "information";
    EHotspotType["ANSWER"] = "answer";
    EHotspotType["QUESTION"] = "question";
    EHotspotType["IMAGE"] = "images";
    EHotspotType["VIDEO"] = "video";
    EHotspotType["AUDIO"] = "audio";
    EHotspotType["INTERFACE"] = "interface";
    EHotspotType["HIGHLIGHT"] = "highlight";
    EHotspotType["MOVEMENT_3D"] = "movement_3D";
})(EHotspotType || (EHotspotType = {}));
export var EHotspotMedia;
(function (EHotspotMedia) {
    EHotspotMedia["IMAGE"] = "images";
    EHotspotMedia["VIDEO"] = "video";
    EHotspotMedia["AUDIO"] = "audio";
})(EHotspotMedia || (EHotspotMedia = {}));
export var EContentDataType;
(function (EContentDataType) {
    EContentDataType["HTML"] = "html";
    EContentDataType["VIDEO"] = "video";
    EContentDataType["AUDIO"] = "audio";
    EContentDataType["IMAGE"] = "image";
})(EContentDataType || (EContentDataType = {}));
